import { RouteRecordRaw } from 'vue-router';

const eventRoutes: RouteRecordRaw[] = [
   {
      path: '/event',
      name: 'event-index',
      component: () => import('@/modules/events/pages/Index.vue'),
   },
];

export default eventRoutes;
